import React from 'react';
import {
  Image, Text, TouchableOpacity, View,
} from 'react-native';
import { img_check } from '../utils/ImagesManagementUtils';

//= ========================================================================
const MyCheckbox = ({
  onValueChanged, value, title, isDisabled = false,
}) => (
  <TouchableOpacity
    style={{
      marginLeft: 0,
      marginTop: 8,
      position: 'absolute',
      height: 24,
      flexDirection: 'row',
    }}
    disabled={isDisabled}
    onPress={() => {
      onValueChanged(!value);
    }}
  >
    <View
      style={{
        width: 20,
        height: 20,
        marginTop: 2,
        borderRadius: 5,
        backgroundColor: '#008cff',
        opacity: isDisabled ? 0.5 : 1.0,
      }}
    >
      {value ? (
        <Image
          fadeDuration={0}
          style={{
            width: 16, height: 16, marginLeft: 2, marginTop: 2,
          }}
          source={img_check}
        />
      ) : (
        <View
          style={{
            width: 16,
            height: 16,
            marginLeft: 2,
            marginTop: 2,
            borderRadius: 3,
            backgroundColor: '#f1f5f9',
          }}
        />
      )}
    </View>

    <Text
      style={{
        marginLeft: 8,
        marginTop: 4,
        fontFamily: 'Rubik-Regular',
        fontSize: 14,
        color: '#001a2f',
      }}
    >
      {title}
    </Text>
  </TouchableOpacity>
);

export default MyCheckbox;
